(function(){
'use strict';

angular.module('classy', ['froala', 'ngSanitize', 'ngAnimate', 'ipCookie', 'ui.router', 'ui.bootstrap', 'ui.bootstrap.tpls', 'ui.bootstrap.dateparser', 'ui.router.metatags', 'ui.sortable', 'ngFileUpload', 'angular-loading-interceptors', 'pickadate', 'angularSpinner', 'oc.lazyLoad', 'monospaced.elastic', 'ngInputModified']);
})();